





















import { Component, Vue, Prop } from 'vue-property-decorator';
import TextAreaField from '@/components/TextAreaField.vue';
import Header from '@/components/Header.vue';
import { ActionButton } from '@/models/action-button';

@Component({
  components: {
    TextAreaField,
    Header,
    Button: () => import('@/components/Button.vue'),
  },
})
export default class TextFieldsWrapper extends Vue {
  @Prop({ type: String, default: () => null }) title!: string | null;
  @Prop({ type: Boolean, default: false }) isNested?: boolean;
  @Prop({ type: Boolean, default: false }) center!: boolean;
  @Prop({ type: Object, default: () => null })
  actionButton!: ActionButton | null;
}
